exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.active.start-date {\n  background-color: #795548 !important;\n  color: #FFF !important; }\n\ntd.available {\n  background-color: #706F6F !important;\n  color: #FFF !important; }\n\ntd.disabled {\n  text-decoration: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/reservation/cours/cours.component.scss
// module id = ../../../../../src/app/reservation/cours/cours.component.scss
// module chunks = main